import React from 'react';
import { withRouter } from 'react-router-dom';

import { Api } from '../Common/rest-api/api-exports';
import FullLoginPage from './components/Full-login';
import localStorage from '../Common/LocalStorage';
import { regExEmail } from '../Common/Helpers';
import { StaticRoutePaths } from '../Common/ClientRoutes';

import LocalizedStrings from 'react-localization';
import { translations } from '../Common/Translations';

let strings = new LocalizedStrings(translations);

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            validCredentials: true,
            credentialsErrorMsg: '',
            email: '',
            validEmail: true,
            emailErrorMsg: ''
        };

        if (localStorage.getFromStorage('lang') === undefined) {
            localStorage.saveInStorage('lang', navigator.language.substring(0, 2));
        }

        strings.setLanguage(localStorage.getFromStorage('lang'));
    }

    updateUsername = e => {
        this.setState({ ...this.state, username: e.target.value });
    };

    updatePassword = e => {
        this.setState({ ...this.state, password: e.target.value });
    };

    updateEmail = e => {
        this.setState({ ...this.state, email: e.target.value });
    };

    loginHandler = () => {
        if (this.state.username !== '' && this.state.password !== '') {
            return Api.Login.login(this.state.username, this.state.password)
                .then(response => {
                    localStorage.saveToken('token', response.token);
                    localStorage.saveToken('refresh_token', response.refresh_token);
                    localStorage.saveUsername(response.username);
                    localStorage.saveInStorage('loginTime', new Date().getTime());
                    localStorage.saveInStorage('expiration_time', response.expiration_time);
                    this.setState({
                        ...this.state,
                        validCredentials: true,
                        credentialsErrorMsg: ''
                    });

                    Api.Users.details()
                        .then(response => {
                            localStorage.saveUsernameRole(response.body.role);
                            localStorage.saveInStorage('userDetails', response.body);
                            this.props.history.push(StaticRoutePaths.HOME);
                        })
                        .catch(error =>  {
                            this.setState({
                                ...this.state,
                                validCredentials: false,
                                credentialsErrorMsg: strings.invalid_user_credentials
                            });
                        });
                })
                .catch(error => {
                    this.setState({
                        ...this.state,
                        validCredentials: false,
                        credentialsErrorMsg: strings.invalid_username_password
                    });
                });
        } else if (this.state.username === '' && this.state.password === '') {
            this.setState({
                ...this.state,
                validCredentials: false,
                credentialsErrorMsg: strings.provide_email_and_password
            });
        } else {
            if (this.state.username === '') {
                this.setState({
                    ...this.state,
                    validCredentials: false,
                    credentialsErrorMsg: strings.provide_email
                });
            } else {
                this.setState({
                    ...this.state,
                    validCredentials: false,
                    credentialsErrorMsg: strings.provide_password
                });
            }
        }
    };

    sendMailHander = () => {
        let regEx = regExEmail();

        if (this.state.email.trim() !== '') {
            if (this.state.email.match(regEx)) {
                this.setState({
                    ...this.state,
                    validEmail: true,
                    emailErrorMsg: ''
                });
                Api.Passwords.edit({ email: this.state.email })
                    .then(response => {
                        this.setState({
                            ...this.state,
                            validEmail: response,
                            emailErrorMsg: ''
                        });
                        this.props.history.push(StaticRoutePaths.LOGIN_RESET_PASSWORD);
                    })
                    .catch(error => {
                        this.setState({
                            ...this.state,
                            validEmail: false,
                            emailErrorMsg: error.body[0].email
                        });
                    });
            } else {
                this.setState({
                    ...this.state,
                    validEmail: false,
                    emailErrorMsg: strings.provide_valid_email
                });
            }
        } else {
            this.setState({
                ...this.state,
                validEmail: false,
                emailErrorMsg: strings.provide_email
            });
        }
    };

    render() {
        return (
            <FullLoginPage
                {...this.state}
                updateUsername={this.updateUsername}
                updatePassword={this.updatePassword}
                loginHandler={this.loginHandler}
                updateEmail={this.updateEmail}
                sendMailHander={this.sendMailHander}
            />
        );
    }
}

export default withRouter(Login);



// WEBPACK FOOTER //
// ./src/customModules/Login/component-login.js